import { toast, Slide } from "react-toastify";
import { JSX } from "react";
import { translateLanguage } from "@/helper/i18n";

type ToastQueueItem = {
    message: string;
    productName: string;
    productNameKh?: string;
    icon: JSX.Element;
    options: { reverse: boolean };
};

let toastQueue: ToastQueueItem[] = [];
let isToastActive = false;

const TranslateLanguage = ({ name, nameKH }: { name: string; nameKH?: string }) => {
    return <>{translateLanguage(name, nameKH ? nameKH : name)}</>;
};

const getToastMarginBottom = () => {
    if (typeof window === "undefined") return "70px";
    return window.innerWidth >= 768 ? "55px" : "70px";
};

export const clearToastQueue = () => {
    toastQueue = [];
    isToastActive = false;
    toast.dismiss();
};

export const showToast = (
    message: string,
    productName: string,
    icon: JSX.Element,
    options: { reverse: boolean },
    productNameKh?: string
) => {
    if (!localStorage.getItem("token")) return;
    toastQueue.push({ message, productName, icon, options, productNameKh });
    processQueue();
};

const processQueue = () => {
    if (!localStorage.getItem("token")) {
        clearToastQueue();
        return;
    }
    if (isToastActive || toastQueue.length === 0) return;

    const { message, productName, icon, options, productNameKh } = toastQueue.shift()!;
    isToastActive = true;

    toast.success(
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {options.reverse ? (
                <>
                    <h1 style={{ display: "inline", fontSize: "16px", fontWeight: "bold" }}>
                        <TranslateLanguage name={productName} nameKH={productNameKh} />
                    </h1>{" "}
                    {message}
                </>
            ) : (
                <>
                    {message}{" "}
                    <h1 style={{ display: "inline", fontSize: "16px", fontWeight: "bold" }}>
                        <TranslateLanguage name={productName} nameKH={productNameKh} />.
                    </h1>
                </>
            )}
        </div>,
        {
            position: "bottom-left",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            closeButton: false,
            transition: Slide,
            onClose: () => {
                isToastActive = false;
                processQueue();
            },
            style: {
                fontSize: "16px",
                color: "#000000",
                whiteSpace: "nowrap",
                wordBreak: "break-word",
                width: "fit-content",
                // maxWidth: "400px",
                padding: "10px 14px",
                borderRadius: "10px",
                marginBottom: getToastMarginBottom(),
            },
            icon,
        }
    );
};
